// src/pages/platform/Channel/modules/headers/ProgressBar.jsx
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const clamp = (v) => Math.max(0, Math.min(100, v));

const ProgressBar = ({
  tokensChecked = 0,
  totalTokens = 0,
  fallbackActive = 0,
  fallbackTotal = 0,
  className = '',
  widthClass = 'w-28',
  heightClass = 'h-7',
  numbersClass = 'text-white/85', // ← добавлено: можно сделать ярче
}) => {
  const { active, total } = useMemo(() => {
    const a = Number.isFinite(tokensChecked) ? Number(tokensChecked) : Number(fallbackActive) || 0;
    const t = Number(totalTokens) || Number(fallbackTotal) || 0;
    return { active: Math.max(0, a), total: Math.max(0, t) };
  }, [tokensChecked, totalTokens, fallbackActive, fallbackTotal]);

  const percent = useMemo(() => (total > 0 ? clamp((active / total) * 100) : 0), [active, total]);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`relative ${widthClass} ${heightClass} rounded-full bg-white/15 ring-1 ring-white/20 overflow-hidden`}>
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-[width] duration-500"
          style={{
            width: `${percent}%`,
            backgroundImage: 'linear-gradient(90deg, #7c3aed, #a21caf, #db2777)',
          }}
        />
        <div className="absolute inset-0 rounded-full shadow-[inset_0_0_10px_rgba(255,255,255,.08)] pointer-events-none" />
      </div>

      <span className={`text-[11px] sm:text-xs tabular-nums select-none ${numbersClass}`}>
        {active} / {total}
      </span>
    </div>
  );
};

ProgressBar.propTypes = {
  tokensChecked: PropTypes.number,
  totalTokens: PropTypes.number,
  fallbackActive: PropTypes.number,
  fallbackTotal: PropTypes.number,
  className: PropTypes.string,
  widthClass: PropTypes.string,
  heightClass: PropTypes.string,
  numbersClass: PropTypes.string,
};

export default ProgressBar;
